import React from "react";

export default function ServiceCard({ icon, title, description, isCenter }) {
  return (
    <div className={`service-card-wrapper ${isCenter ? "is-center" : ""}`}>

      {/* Rotating Background Layer */}
      <div className="service-card-bg " />

      {/* Content Layer */}
      <div className="service-card-content d-flex flex-column align-items-center justify-content-center text-center text-white h-100 p-4 p-lg-5 common-border-2">

        {/* Icon Circle */}
        {icon && (
          <div className="service-icon-circle d-flex align-items-center justify-content-center rounded-circle mb-4">
            <img src={icon} alt={title} className="service-icon-img" />
          </div>
        )}

        {/* Title */}
        <h3 className="service-card-title fw-medium mb-3">
          {title}
        </h3>

        {/* Description */}
        <p className="service-card-desc text-secondary mb-0">
          {description}
        </p>

      </div>
    </div>
  );
}
